module.exports = __webpack_public_path__ + "assets/Attach-File.9f733fda.svg";